export const ngonDynamicTitleContext = 'ngonDynamicTitle';
